<template>
  <div class="promo-wrap pt-100 pb-75">
    <div class="container">
      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-6 col-md-6"
          v-for="feature in features"
          :key="feature.id"
          data-aos="fade-left"
          data-aos-duration="1200"
          :data-aos-delay="feature.datadelay"
        >
          <div class="promo-card style2">
            <div class="promo-title">
              <div class="promo-icon">
                <i :class="feature.icon"></i>
              </div>
              <h3>{{ feature.title }}</h3>
            </div>
            <p>
              {{ feature.shortDesc }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurFeatures",
  data: () => ({
    features: [
      {
        id: 1,
        datadelay: "200",
        icon: "flaticon-chiropractic",
        title: "Chiropratic Therapy",
        shortDesc:
          "It is a long established fact that reader will be distract by the readable content of a page when looking at it.",
      },
      {
        id: 2,
        datadelay: "300",
        icon: "flaticon-massage",
        title: "Massaga Therapy",
        shortDesc:
          "It is a long established fact that reader will be distract by the readable content of a page when looking at it.",
      },
      {
        id: 3,
        datadelay: "400",
        icon: "flaticon-injury",
        title: "Sports Injury",
        shortDesc:
          "It is a long established fact that reader will be distract by the readable content of a page when looking at it.",
      },
    ],
  }),
});
</script>